var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{ref:"trigger",on:{"click":function($event){return _vm.show()}}},[_vm._t("trigger")],2),_c('span',{ref:"content",class:{ popover: true, visible: _vm.visible, 'md-tooltip': true }},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }